'use client'

import _ from 'lodash'
import { twMerge } from 'tailwind-merge'
import { useState, useEffect } from 'react'
import { useQuery } from "@tanstack/react-query"
import { forwardRef } from 'react'
import { Combobox, ComboboxInput, ComboboxOptions, ComboboxOption } from '@headlessui/react'
import { otherApi } from '@/api'

type Props = {
  value?: string | number | null | any
  placeholder?: string
  maxLength?: number
  disabled?: boolean
  optional?: boolean
  onChange: (val: string | any) => void
} & React.ComponentPropsWithoutRef<'input'>

export const LocationAutoComplete = forwardRef<HTMLInputElement, Props>((props: Props, ref: any) => {
  const { value, onChange } = props

  // query
  const [query, setQuery] = useState('')
  const { data } = useQuery({
    queryKey: [query],
    queryFn: () => otherApi.location(query),
    refetchOnWindowFocus: false,
  })

  // set result
  const [option, setOption] = useState<string[]>([])
  useEffect(() => {
    setOption(data?.data || [])
  }, [data])

  const errMsg = _.get(props, 'data-error')

  return (
    <Combobox as='div' value={value} onChange={(val) => onChange(val || '')}>
      <label htmlFor='locationAutoComplete' className='form-label'>
        Location <span className='font-light ml-1.5 text-zinc-600 dark:text-zinc-400'>(City, State)</span>
      </label>
      <div className={twMerge('relative text-sm mt-1')}>
        <ComboboxInput id='locationAutoComplete' as='input' className='form-listbox' onChange={(e) => setQuery(e.target.value)} ref={ref} />
        <ComboboxOptions transition className='form-options'>
          {_.size(query) > 0 && (
            <ComboboxOption key={-1} value={query} className='form-option'>
              {query}
            </ComboboxOption>
          )}
          {
            _.map(option, (d, idx) => {
              return (
                <ComboboxOption key={idx} value={d} className='form-option'>
                  <span className='block truncate group-data-selected:font-semibold'>{d}</span>
                </ComboboxOption>
              )
            })
          }
        </ComboboxOptions>
      </div>
      {
        errMsg && <div className='form-error-message'>{errMsg}</div>
      }
    </Combobox >
  )
})

